module.exports = __webpack_public_path__ + "static/img/logo-xes-garrotxa-1.f430d71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-xes-garrotxa-1.png
// module id = iGhl
// module chunks = 1